export default __webpack_public_path__ + "static/media/DharmaGothicE_Regular_I.930f14eb.otf";